import { Button } from 'component/Button'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { getLang } from 'i18n/config/LanguageDetector'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './ProductInfo.module.scss'

type Props = {
  inference: InferenceStore
}

export const ProductInfo = observer(({ inference }: Props) => {
  const { product, brand, links } = inference
  const lang = getLang()
  const { hide_name_for_en, combine } = opt.options
  const hide_name = lang === 'en' && hide_name_for_en && combine
  const buy = !!links || store.customBuy

  const onLink = useLatestCallback(() => {
    controller.openBuy(inference)
  })

  if (!brand && !product && !buy) {
    return null
  }

  return <Vertical>
    {brand && <Typo size={11} medium upper secondary>{brand}</Typo>}
    {brand && product && <Gap height={4} />}
    {product && !hide_name && <Typo size={14} medium upper>{product}</Typo>}
    {(brand || product) && links && <Gap height={12} />}
    {buy && <Button className={css.button} primary large wide action={onLink}>
      {i18n('BuyInTsum')}
    </Button>}
  </Vertical>
})

export function renderProductInfo(inference: InferenceStore | undefined) {
  if (!inference) return null
  if (!opt.inline || !opt.tsum) return null

  const { product, brand, links } = inference
  const buy = !!links || store.customBuy
  if (!brand && !product && !buy) return null

  return <ProductInfo inference={inference} />
}
